import { Children } from "react";
import styled from "styled-components";

const Root = styled.div`
  padding: 10px 0;
`;

const FormGroup = ({ children }) =>
  Children.map(children, (child) => (child ? <Root>{child}</Root> : child));

export default FormGroup;
